const lordiconCdnUrl = `${process.env.LORDICON_CDN_URL ?? 'https://dev-lordicon.cdn.classy-test.org'}`;
export const ICON_MAPPINGS = {
  'love-heart': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-20-love-heart.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-20-love-heart.json`
    },
    name: 'Love Heart',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-heartbeat': {
        label: 'heartbeat'
      },
      'hover-match': {
        label: 'match'
      },
      'morph-glitter': {
        label: 'glitter'
      },
      'morph-slider': {
        label: 'slider'
      },
      'morph-two-hearts': {
        label: 'two hearts'
      }
    }
  },
  calendar: {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-28-calendar.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-28-calendar.json`
    },
    name: 'Calendar',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-pinch': {
        label: 'pinch'
      },
      'hover-flutter': {
        label: 'flutter'
      }
    }
  },
  'like-thumb-up': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-267-like-thumb-up.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-267-like-thumb-up.json`
    },
    name: 'Thumbs Up',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-up': {
        label: 'up'
      }
    }
  },
  'coin-dollar': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-291-coin-dollar.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-291-coin-dollar.json`
    },
    name: 'Dollar Coin',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-pinch': {
        label: 'pinch'
      },
      'morph-coins': {
        label: 'coins'
      }
    }
  },
  coins: {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-298-coins.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-298-coins.json`
    },
    name: 'Coins',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-jump': {
        label: 'jump'
      }
    }
  },
  'leaves-eco': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-401-leaves-eco.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-401-leaves-eco.json`
    },
    name: 'Eco',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-spin': {
        label: 'spin'
      }
    }
  },
  gift: {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-412-gift.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-412-gift.json`
    },
    name: 'Gift',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-squeeze': {
        label: 'squeeze'
      },
      'morph-open': {
        label: 'open'
      }
    }
  },
  'world-care': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-435-world-care.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-435-world-care.json`
    },
    name: 'World Care',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  'love-care': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-436-love-care.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-436-love-care.json`
    },
    name: 'Care',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  'environment-eco-care': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-437-environment-eco-care.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-437-environment-eco-care.json`
    },
    name: 'Environment',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  church: {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-482-church.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-482-church.json`
    },
    name: 'Church',
    animations: {
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  'world-globe': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-735-world-globe.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-735-world-globe.json`
    },
    name: 'Globe',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-roll': {
        label: 'roll'
      }
    }
  },
  'statue-sculpture': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-777-statue-sculpture.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-777-statue-sculpture.json`
    },
    name: 'Statue',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  butterfly: {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-1151-butterfly.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-1151-butterfly.json`
    },
    name: 'Butterfly',
    animations: {
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  'tail-whale': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-1157-tail-whale.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-1157-tail-whale.json`
    },
    name: 'Tail Whale',
    animations: {
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  'animal-shelter': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-1177-animal-shelter.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-1177-animal-shelter.json`
    },
    name: 'Animal Shelter',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  'card-heart': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-1453-card-heart.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-1453-card-heart.json`
    },
    name: 'Card Heart',
    animations: {
      'in-reaveal': {
        label: 'reveal'
      },
      // not a typo
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  'heart-balloon': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-1542-heart-balloon.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-1542-heart-balloon.json`
    },
    name: 'Heart Balloon',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  'pray-hands': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-1673-pray-hands.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-1673-pray-hands.json`
    },
    name: 'Pray Hands',
    animations: {
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  'growing-plant': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-1827-growing-plant.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-1827-growing-plant.json`
    },
    name: 'Growing Plant',
    animations: {
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  'tree-planting': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-1850-tree-planting.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-1850-tree-planting.json`
    },
    name: 'Tree Planting',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  mosque: {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-1923-mosque.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-1923-mosque.json`
    },
    name: 'Mosque',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  'orthodox-church': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-1944-orthodox-church.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-1944-orthodox-church.json`
    },
    name: 'Orthodox Church',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  'star-of-david': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-1980-star-of-david.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-1980-star-of-david.json`
    },
    name: 'Star of David',
    animations: {
      'in-reaveal': {
        label: 'reveal'
      },
      // not a typo
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  refund: {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-2115-refund.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-2115-refund.json`
    },
    name: 'Refund',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-pinch': {
        label: 'pinch'
      }
    }
  },
  'religion-in-general': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-2341-religion-in-general.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-2341-religion-in-general.json`
    },
    name: 'Religions',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-spin': {
        label: 'spin'
      }
    }
  },
  'recurring-cash': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-2531-recurring-cash.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-2531-recurring-cash.json`
    },
    name: 'Recurring Cash',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-spin': {
        label: 'spin'
      }
    }
  },
  'calendar-subscription': {
    s3Url: {
      outline: `${lordiconCdnUrl}/outline/wired-outline-2613-calendar-subscription.json`,
      gradient: `${lordiconCdnUrl}/gradient/wired-gradient-2613-calendar-subscription.json`
    },
    name: 'Calendar Subscription',
    animations: {
      'in-reveal': {
        label: 'reveal'
      },
      'hover-click': {
        label: 'click'
      },
      'hover-pinch': {
        label: 'pinch'
      }
    }
  }
};